/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Col_TotalInputs */

const vi_einvoice_draft_col_total = /** @type {(inputs: Einvoice_Draft_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cộng VAT`)
};

/**

* @param {Einvoice_Draft_Col_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_col_total = /** @type {((inputs?: Einvoice_Draft_Col_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Col_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_col_total(inputs)
});